import React from "react";
import { ListTable } from "../../Table/listTable/listTable";
import {
  useGetSchoolBlocks,
  useRemoveBlock,
} from "../../../hooks/blockHooks/block.hooks";
import { transformBlockListTableData } from "../../../Services/transformer/transformBlockListTableData";
import { blockListTitles } from "../../../Constants/tableTitles/ListTableTitle/blockList.titles";
import { RemoveBlockModal } from "../RemovBlockModal";
import { getValue } from "../../../utils/object.utils";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../../Redux/Slices/alert.slice";
import { parseApiError } from "../../../Helper/apiError.helper";
import { EditBlockModal } from "../EditBlockModal";

export const BlockList = () => {
  const dispatch = useDispatch();

  const [openRemoveModal, setOpenRemoveModal] = React.useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);

  const { isLoading: isBlockListLoading, data: schoolBlockData } =
    useGetSchoolBlocks();

  const { isLoading: isRemoving, mutate: removeBlock } = useRemoveBlock({
    onSuccess: () => {
      dispatch(setSuccessMessage("Block removed successfully."));
      setOpenRemoveModal(false);
    },
    onError: (error: Error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const [selectedBranchToRemove, setSelectedBranchToRemove] =
    React.useState<any>(null);

  const [selectedBlockToEdit, setSelectedBranchToEdit] =
    React.useState<any>(null);

  const handleBlockRemove = () => {
    const blockId = getValue(selectedBranchToRemove, "id");

    if (!blockId) return null;

    removeBlock(blockId);
  };

  return (
    <div>
      <ListTable
        titles={blockListTitles}
        data={schoolBlockData}
        isDataLoading={isBlockListLoading}
        transformFn={transformBlockListTableData}
        moreOptons={{
          onEdit: (data: any) => {
            setSelectedBranchToEdit(data);
            setOpenEditModal(true);
          },
          onRemove: (data: any) => {
            setSelectedBranchToRemove(data);
            setOpenRemoveModal(true);
          },
        }}
      />
      <RemoveBlockModal
        open={openRemoveModal}
        handleBlockRemove={handleBlockRemove}
        onClose={() => {
          setOpenRemoveModal(false);
        }}
        selectedBranchToRemove={selectedBranchToRemove}
        isProcessingConfirmation={isRemoving}
      />

      <EditBlockModal
        open={openEditModal}
        selectedBlock={selectedBlockToEdit}
        onClose={() => {
          setOpenEditModal(false);
        }}
      />
    </div>
  );
};
